// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"9c2ae6ee","497":"9abc24b4"}[chunkId] + ".chunk.css";
};